export const encodeBase64 = (str: string): string => {
  return typeof window !== "undefined"
    ? window.btoa(str)
    : Buffer.from(str).toString("base64");
};

export const decodeBase64 = (base64: string): string => {
  return typeof window !== "undefined"
    ? window.atob(base64)
    : Buffer.from(base64, "base64").toString("utf-8");
};
